import React, { useContext, useState } from 'react';
import PlanCard from './PlanCard';
import { subscribe } from 'src/services/billing';
import {
	formatPrice,
	getPlanIntervalQty,
	getPlanIntervalText,
	getPlanPrice,
} from 'src/lib/utils/billing';
import UserContext from 'src/contexts/user/UserContext';
import { useRightSidebarContext } from 'src/contexts/app/RightSidebarContext';
import { customToast, toastSuccess } from 'src/services/toast';
import { IPlan } from 'src/models/account/interfaces';

interface PlanListProps {
	plans: IPlan[];
	currentPlan: IPlan;
}

const PlanList: React.FC<PlanListProps> = ({ plans, currentPlan }) => {
	const { fetchSubscription, account } = useContext(UserContext);
	const { openSupport } = useRightSidebarContext();
	const [isLoading, setIsLoading] = useState(false);
	const selectedLevel = currentPlan?.level;

	const handleUpgrade = async (planId: string) => {
		try {
			setIsLoading(true);
			await subscribe(planId);
			await fetchSubscription();
			toastSuccess('Subscription upgraded successfully');
		} catch (error) {
			console.error(error);
			customToast('Failed to upgrade subscription. Please try again.', 'error');
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<>
			{plans
				.filter((plan) => !plan.hidden)
				.map((plan) => {
					const price = getPlanPrice(
						plan.prices,
						account?.subscription?.planId,
					);

					const intervalQty = getPlanIntervalQty(
						plan.prices,
						account?.subscription?.planId,
					);

					const intervalText = getPlanIntervalText(intervalQty ?? 1);

					const isSelected = plan._id === currentPlan?._id;
					let actionButtonText = '';
					let onActionButton = () => {};

					if (!isSelected && selectedLevel !== undefined) {
						if (plan.level < selectedLevel) {
							actionButtonText = 'Downgrade';
							onActionButton = () => openSupport();
						} else if (plan.level > selectedLevel) {
							actionButtonText = 'Upgrade';
							onActionButton = () => handleUpgrade(plan._id);
						}
					}

					return (
						<PlanCard
							key={plan._id}
							title={plan.name}
							features={plan.features}
							price={formatPrice(price ?? 0)}
							actionButtonText={actionButtonText}
							onActionButton={onActionButton}
							isSelected={isSelected}
							isLoading={isLoading}
							intervalText={intervalText}
						/>
					);
				})}
		</>
	);
};

export default PlanList;
